import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { FormikTextarea } from "@/features/forms/components/formik-controls";

/**
 * Part VI — Additional information (legacy `sr_part6.php`). One free-text field;
 * sensitive content is never logged.
 */
export function SrPart6({ onNext }: { onNext: () => void }) {
  return (
    <div className="flex flex-col gap-6">
      <Card className="grid gap-2 p-6">
        <Label htmlFor="any_other_information">
          <span className="text-muted-foreground mr-2 font-mono">24</span>
          Any other information you want us to consider
        </Label>
        <FormikTextarea name="any_other_information" rows={6} />
      </Card>

      <div className="flex justify-end">
        <Button type="button" variant="outline" onClick={onNext}>
          Go to Part VII <ArrowRight />
        </Button>
      </div>
    </div>
  );
}
